import React, { useEffect, useState } from "react";
import { httpReauest } from "../../../utils/httpRequest";
import Loading from "../Loading";
import { CDN_BASE_URL } from "../../../config";
import { Link } from "react-router-dom";
import BlogCard from "../card/BlogCard";

const BlogsMobile = ({ text }) => {
  const [blogs, setBlogs] = useState([]);
  const [slider, setslider] = useState();
  const [loading, setloading] = useState();

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (text) {
      getSearch();
    } else {
      getData();
    }
  }, [text]);

  async function getSearch(params) {
    setloading(true);
    await httpReauest("GET", "/blog?search_key=" + text, {}, {}).then(
      ({ data }) => {
        setBlogs(data?.data);
      }
    );
    setloading(false);
  }

  async function getData() {
    setloading(true);
    await httpReauest("GET", "/blog", {}, {}).then(({ data }) => {
      setBlogs(data?.data);
    });

    setloading(false);
  }

  if (loading) {
    return <Loading />;
  }

  console.log(blogs);

  return (
    <div className="col-span-full flex flex-col gap-6">
      {blogs?.map((item) => (
        <BlogCard data={item} mobile/>
      ))}
    </div>
  );
};

export default BlogsMobile;
